import { defineComponent as _defineComponent } from 'vue'
import DialogContentLayout from "@/components/common/DialogContentLayout.vue";
import { ref, reactive, watch, computed, getCurrentInstance } from 'vue'
import customerService from '@/services/customer'
import { getPhoneValidationRules, phoneFormatFilterInternational, phoneRaw as phoneRawUtil } from "@/utils/phone";
type PhoneForm = {
  phone: string;
  confirmCheck: boolean;
  submitting: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TripRecievedContent',
  props: {
    customerId: null,
    phone: null
  },
  emits: ['update:phone','refresh', 'next'],
  setup(__props: any, { emit }) {

const props = __props as {
  customerId: number
  phone: string
};

const { proxy } = getCurrentInstance()!;
const t = proxy.$t.bind(proxy);





const tripReceivedForm = ref()
const showConfirmCheckbox = ref(true)

const phoneForm = reactive<PhoneForm>({
  phone: phoneFormatFilterInternational(props.phone),
  confirmCheck: true,
  submitting: false
})

const phoneRaw = computed(() => phoneRawUtil(phoneForm.phone))

watch(() => props.phone, (val) => {
  if (val !== phoneForm.phone) phoneForm.phone = val
})

const phoneRules = getPhoneValidationRules((key) => t(key).toString())

// Format the phone number on blur using phoneFormatFilterInternational
const onPhoneBlur = (e: Event) => {
  const target = e.target as HTMLInputElement
  const formatted = phoneFormatFilterInternational(target.value)
  phoneForm.phone = formatted
}

const submitPhoneNumber = async (): Promise<void> => {
    const form = tripReceivedForm.value as any
    if (!form.validate()) {
      return
    }

    phoneForm.submitting = true
    try {
        await customerService.updateSMS(props.customerId, {
          phoneNumber: phoneRaw.value,
        })
    } catch (err: any) {
      console.error(`Error updating SMS for customer ${props.customerId} failed: ${err.response.data.message}`)
    }
    phoneForm.submitting = false
    emit('update:phone', phoneForm.phone)
    emit('refresh')
    emit('next')
  }


return { __sfc: true,proxy, t, emit, props, tripReceivedForm, showConfirmCheckbox, phoneForm, phoneRaw, phoneRules, onPhoneBlur, submitPhoneNumber, DialogContentLayout }
}

})